import { ADDONS_CATEGORIES } from 'src/modules/MyPlan/utils'
import moment from 'moment'

const CHEF_IMG_URL_SOURCE =
  process.env.REACT_APP_CHEF_IMG_URL_SOURCE + '/media/avatar/'

export const getOrderTitle = items => {
  const { meals } = items.reduce(
    (data, item) =>
      ADDONS_CATEGORIES.includes(item.product.category_id)
        ? {
            ...data,
            addons: data.addons + item.qty
          }
        : {
            ...data,
            meals: data.meals + item.qty
          },
    { meals: 0, addons: 0 }
  )

  return [
    `${meals} ${meals > 1 ? 'meals' : 'meal'}`
    // ...(addons
    //   ? [`and other ${addons} ${addons > 1 ? 'products' : 'product'}`]
    //   : []),
    // "you've chosen"
  ]
    .join(' ')
    .trim()
}

export const getMeals = items => {
  return items.map(item => {
    return {
      ...item,
      id: +item.product.id,
      mealName: `${item.product.name ? item.product.name : ''}`.trim(),
      mealDescription: `${
        item.product.short_description ? item.product.short_description : ''
      }`.trim(),
      name: `${item.product.name ? item.product.name : ''} ${
        item.product.short_description ? item.product.short_description : ''
      }`.trim(),
      image:
        (item.product.image || '').substr(-12) === 'no_selection'
          ? ''
          : item.product.image,
      chef_firstname: item.product.chef_firstname
        ? item.product.chef_firstname.trim()
        : '',
      chef_lastname: item.product.chef_lastname
        ? item.product.chef_lastname.trim()
        : '',
      chefId: item.product.chef_id,
      isCelebrity: item.product.is_celebrity_chef === '1',
      chefImage: CHEF_IMG_URL_SOURCE + item.product.bannerpic,
      quantity: item.qty,
      meatType: item.product.meat_type,
      tags: item.product.calories
        ? [{ label: `${item.product.calories} cal` }]
        : [],
      stars: item.product.stars,
      review: item.product.review
    }
  })
}

export const formatTime = time => {
  if (!time) {
    return ''
  }
  return moment(time, 'HH:mm').format('h:mmA')
}

export const checkEmptyStateDate = (year, month) =>
  !Object.keys(year).length && !Object.keys(month).length

export const matchDetail = (order, details) =>
  details.find(d => +d.magentoOrderId === +order.id)

export const quoteToOrder = (quote, order) =>
  Object.assign(
    {
      ...order
    },
    {
      grandTotal: quote.total,
      items: quote.detail
        .map(item => {
          const product = order.items.find(i => +i.product.id === +item.id)
          return Object.assign(
            {
              ...item
            },
            {
              product: product ? product.product : null,
              qty: item.qty,
              price: item.price,
              charged: item.charged
            }
          )
        })
        .filter(item => !!item.product)
    }
  )
